import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ServicesDetailsComponent } from './components/pages/services-details/services-details.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { ProjectsComponent } from './components/pages/projects/projects.component';
import { ProjectsDetailsComponent } from './components/pages/projects-details/projects-details.component';
import { ErrorComponent } from './components/pages/error/error.component';
import {LoginComponent} from "./components/pages/Account/Components/login/login.component";
import {RegisterComponent} from "./components/pages/Account/Components/register/register.component";
import {ShowAllPowerBiComponent} from "./components/pages/show-all-power-bi/show-all-power-bi.component";
import {ShowPowerBiComponent} from "./components/pages/show-power-bi/show-power-bi.component";
import {CategoryDetailsComponent} from "./components/pages/category-details/category-details.component";

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'home', component: HomeOneComponent},
    {path: 'about', component: AboutComponent},
    {path: 'projects', component: ProjectsComponent},
    {path: 'myEmails', component: ShowAllPowerBiComponent},
    {path: 'email-details/:id', component: ShowPowerBiComponent},
    {path: 'projects-details/:id', component: ProjectsDetailsComponent},
    {path: 'pricing', component: PricingComponent},
    {path: 'services', component: ServicesComponent},
    {path: 'services-details/:id', component: ServicesDetailsComponent},
    {path: 'category-details/:id', component: CategoryDetailsComponent},
    {path: 'error', component: ErrorComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'Account/login', component: LoginComponent},
    {path: 'Account/register', component: RegisterComponent},
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'error',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
